import { notification } from "antd"
import { Radio } from "antd"
import { Form } from "formsy-semantic-ui-react"
import * as R from "ramda"
import React, { Component } from "react"
import { Button, Confirm, Label, Modal } from "semantic-ui-react"
import { getEventBySlug } from "../../api/async/events"
import { getOrders, patchOrder } from "../../api/async/orders"

class EditOrder extends Component {
  state = {
    racesDetail: [],
    confirmOpen: false,
    addons: [],
    selected_shirt: [],
    groups: []
  }

  componentDidMount = async () => {
    const orderData = await getOrders({
      id: this.props.match.params.id
    })

    const order = orderData.data[0]

    const eventSlug = order.event.slug

    this.setState({ orderId: order.id })
    this.setState({ eventId: order.event.id })
    this.setState({ numberOfshirt: order.addons.length })
    this.setState({
      selected_shirt: order.addons.map(each => each.addon.id)
    })
    const event = await getEventBySlug(eventSlug)
    this.setState({ event: event.data })
    this.setState({ addons: event.data.addons })

    if (order.is_paid) {
      this.props.history.push("/")
      notification.warning({
        message: `คุณได้ชำระเงินแล้วไม่สามารถแก้ไขการสมัครได้`
      })
    }
  }

  handleSubmit = () => {
    this.setState({ disableSubmit: true })
    patchOrder(this.state, this.state.orderId).then(res => {
      if (res.status <= 201) {
        this.setState({ disableSubmit: false })
        this.props.history.push(`/orders/${res.data.id}`)
      }
    })
  }

  handleChange = (e, { name, value }) => {
    if (name === "numberOfshirt") {
      const { selected_shirt, numberOfshirt } = this.state
      if (numberOfshirt > value) {
        this.setState({ selected_shirt: selected_shirt.splice(0, value) })
      }
      if (value === "no_shirt") {
        this.setState({ numberOfshirt: 0 })
        this.setState({ selected_shirt: [] })
        return
      }
    }
    this.setState({ [name]: value })
  }
  handleRadioChange = e => {
    const { selected_shirt } = this.state
    const shirtId = e.target.value
    const selectShirtIndex = e.target.selectShirtIndex

    selected_shirt[selectShirtIndex] = shirtId
    this.setState({ [e.target.name]: selected_shirt })
  }

  render() {
    const { event, selected_shirt, addons } = this.state

    const errorLabel = <Label color="red" pointing />

    return (
      <React.Fragment>
        <Form
          id="first-step"
          style={{ marginBottom: "10px" }}
          onValidSubmit={() => this.setState({ confirmOpen: true })}
          onValid={this.enableButton}
          onInvalid={this.disableButton}
        >
          <h3>เสื้อวิ่ง {R.path(["title"], event)} </h3>
          <div>
            <img src={R.path(["addon_main_image"], this.state.event)} />
          </div>
          <div style={{ marginTop: 15 }}>
            <a onClick={() => this.setState({ openSizeChart: true })}>
              คลิกเพื่อดูขนาดเสื้อ
            </a>
            <Modal
              open={this.state.openSizeChart}
              onClose={() => this.setState({ openSizeChart: false })}
              closeOnEscape
              closeOnDimmerClick
            >
              <Modal.Header>รายละเอียดขนาดของเสื้อ</Modal.Header>
              <Modal.Content>
                <Modal.Description>
                  <img src={R.path(["size_chart"], this.state.event)} />
                  <Button
                    color="teal"
                    onClick={() => this.setState({ openSizeChart: false })}
                  >
                    ปิด
                  </Button>
                </Modal.Description>
              </Modal.Content>
            </Modal>
          </div>
          <div style={{ marginTop: "10px" }}>
            <h3>จำนวนเสื้อที่ต้องการสั่ง</h3>
            <Form.Group widths="equal">
              <Form.Select
                name="numberOfshirt"
                onChange={this.handleChange}
                value={this.state.numberOfshirt}
                placeholder="กรุณาเลือกจำนวนเสื้อที่ต้องการ"
                selection
                options={[
                  { key: 1, text: "ไม่รับเสื้อ", value: "no_shirt" },
                  { key: 2, text: 1, value: 1 },
                  { key: 3, text: 2, value: 2 },
                  { key: 4, text: 3, value: 3 },
                  { key: 5, text: 4, value: 4 },
                  { key: 6, text: 5, value: 5 }
                ]}
              />
            </Form.Group>
            {[...Array(this.state.numberOfshirt || 0).keys()].map(x => (
              <Radio.Group
                name="selected_shirt"
                value={selected_shirt[x]}
                style={{ marginBottom: "1em", marginTop: "1em" }}
                onChange={this.handleRadioChange}
              >
                <h5>เสื้อตัวที่ {x + 1}</h5>
                {addons.map((each, i) => (
                  <React.Fragment>
                    {i === 9 && <br />}
                    {i === 9 && <br />}
                    <Radio.Button
                      checked={false}
                      selectShirtIndex={x}
                      value={each.id}
                    >
                      {each.title}
                    </Radio.Button>
                  </React.Fragment>
                ))}
              </Radio.Group>
            ))}
          </div>
          <Button
            color="teal"
            type="submit"
            form="first-step"
            style={{ marginTop: "10px" }}
          >
            ต่อไป
          </Button>
        </Form>
        <Confirm
          open={this.state.confirmOpen}
          cancelButton="แก้ไข"
          confirmButton="ตกลง"
          content="คุณยืนยันที่จะเปลี่ยนแปลงคำสั่งซื้อใช่หรือไม่"
          onCancel={() => this.setState({ confirmOpen: false })}
          onConfirm={this.handleSubmit}
        />
      </React.Fragment>
    )
  }
}

export default EditOrder



// WEBPACK FOOTER //
// /opt/build/repo/src/containers/OrderEvent/editOrder.js